<template>
  <div id="switch-button" class="flex items-center">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="switch-item"
      :class="{ selected: isSelected(item.key) }"
    >
      <div class="switch-item-label" :for="item.key" @click="clickButton(item)">
        <div class="flex items-center" :class="item.text ? 'p-3' : 'p-2'">
          <feather-icon
            v-if="item.icon"
            :icon="item.icon"
            svgClasses="h-4 w-4"
          />

          <!-- ラベルにアイコンとテキストが両方入る場合、余白を入れる -->
          <div v-if="item.icon && item.text" class="mr-1"></div>

          <span class="switch-item-label-text" v-if="item.text">{{
            item.text
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      required: true,
      type: Array,
      default: () => { [] }
    },
    defaultSelected: {
      required: true,
    }
  },
  data() {
    return {
    }
  },
  computed: {
    selectedItem() {
      return this.defaultSelected
    },
  },
  methods: {
    isSelected(item) {
      return item === this.selectedItem;
    },
    clickButton(item) {
      item.selectedMethod();
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#switch-button {
  .switch-item {
    border-top: 1px solid $aisea-blue;
    border-bottom: 1px solid $aisea-blue;
    border-left: 1px solid $aisea-blue;
    color: $aisea-blue;
    cursor: pointer;
    line-height: 1;
    opacity: 1;
  }

  .selected {
    background-color: $aisea-blue;
    color: $aisea-white;
    font-weight: 600;
  }

  .switch-item:first-child {
    border-radius: 4px 0px 0px 4px;
  }

  .switch-item:last-child {
    border-right: 1px solid $aisea-blue;
    border-radius: 0px 4px 4px 0px;
  }

  .switch-item-label-text {
    white-space: nowrap;
  }
}
</style>